module.exports = __webpack_public_path__ + "static/img/legal.aa77d61a.gif";